// src/App.jsx
import { Routes, Route } from "react-router-dom";
import { useState } from "react";
import Accesos from "./components/Accesos"
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import Productos from "./components/Productos";
import Ventas from "./components/Ventas";
import Categorias from "./components/Categorias";
import Sucursales from "./components/Sucursales";
import Ingresos from "./components/Ingresos";
import Proveedores from "./components/Proveedores";
import Clientes from "./components/Clientes";
import Usuarios from "./components/Usuarios";
import Permisos from "./components/Permisos";
import Modulos from "./components/Modulos";
import Configuracion from "./components/Configuracion";
import PrivateRoute from "./components/PrivateRoute";
import Loader from "./components/Loader";
import Registro from "./components/Registro";
import ReporteGeneral from "./components/ReporteGeneral";
import ReporteIngresosProductos from "./components/ReporteIngresosProductos";
import ReporteExistencias from "./components/ReporteExistencias";
import NotFound from "./components/NotFound";
import PagosDetalle from "./components/PagosDetalle";
import VentasCocina from "./components/VentasCocina";
import Mesas from "./components/Mesas";
import Cocina from "./components/Cocina";
import TiposVenta from "./components/TiposVenta";
import VentasGeneral from "./components/VentasGeneral";
import Insumos from "./components/Insumos";
import Recetas from "./components/Recetas";
import IngresosInsumos from "./components/IngresosInsumos";
import Consultorios from "./components/Consultorios";
import ProcedimientosOdontologia from "./components/ProcedimientosOdontologia";
import TratamientosOdontologia from "./components/TratamientosOdontologia";
import CitasOdontologia from "./components/CitasOdontologia";
import TiposTratamientoOdontologia from "./components/TiposTratamientoOdontologia";
import HorariosOdontologia from "./components/HorariosOdontologia";
import CalendarioCitasOdontologia from "./components/CalendarioCitasOdontologia";
import ListadoCitasOdontologia from "./components/ListadoCitasOdontologia";
import MedicosOdontologia from "./components/MedicosOdontologia";
import ConfiguracionOdontologia from "./components/ConfiguracionOdontologia";





function App() {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <>
      {isLoading && <Loader />}
      <Routes>
        <Route path="/" element={<Login setIsLoading={setIsLoading} />} />

        <Route path="registro" element={<Registro />} />

        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        >
          <Route path="dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="productos" element={<PrivateRoute><Productos /></PrivateRoute>} />
          <Route path="ventas" element={<PrivateRoute><Ventas /></PrivateRoute>} />
          <Route path="configuracion" element={<PrivateRoute><Configuracion /></PrivateRoute>} />
          <Route path="categorias" element={<PrivateRoute><Categorias /></PrivateRoute>} />
          <Route path="sucursales" element={<PrivateRoute><Sucursales /></PrivateRoute>} />
          <Route path="ingresos" element={<PrivateRoute><Ingresos /></PrivateRoute>} />
          <Route path="proveedores" element={<PrivateRoute><Proveedores /></PrivateRoute>} />
          <Route path="clientes" element={<PrivateRoute><Clientes /></PrivateRoute>} />
          <Route path="usuarios" element={<PrivateRoute><Usuarios /></PrivateRoute>} />
          <Route path="accesos" element={<PrivateRoute><Accesos /></PrivateRoute>} />
          <Route path="permisos" element={<PrivateRoute><Permisos /></PrivateRoute>} />
          <Route path="modulos" element={<PrivateRoute><Modulos /></PrivateRoute>} />
          <Route path="reportes/general" element={<PrivateRoute><ReporteGeneral /></PrivateRoute>} />
          <Route path="reportes/ingresos-productos" element={<PrivateRoute><ReporteIngresosProductos /></PrivateRoute>} />
          <Route path="reportes/existencias" element={<PrivateRoute><ReporteExistencias /></PrivateRoute>} />
          <Route path="pagosdetalle/list" element={<PrivateRoute><PagosDetalle /></PrivateRoute>} />
          <Route path="ventas-cocina/:idMesa?" element={<PrivateRoute><VentasCocina /></PrivateRoute>} />
          <Route path="mesas" element={<PrivateRoute><Mesas /></PrivateRoute>} />
          <Route path="cocina" element={<PrivateRoute><Cocina /></PrivateRoute>} />
          <Route path="tipos-venta" element={<PrivateRoute><TiposVenta /></PrivateRoute>} />
          <Route path="ventas-general/:idTipo?" element={<PrivateRoute><VentasGeneral /></PrivateRoute>} />
          <Route path="insumos" element={<PrivateRoute><Insumos /></PrivateRoute>} />
          <Route path="recetas" element={<PrivateRoute><Recetas /></PrivateRoute>} />
          <Route path="ingresos-insumos" element={<PrivateRoute><IngresosInsumos /></PrivateRoute>} />
          <Route path="consultorios" element={<PrivateRoute><Consultorios /></PrivateRoute>} />
          <Route path="procedimientos-odontologia" element={<PrivateRoute><ProcedimientosOdontologia /></PrivateRoute>} />
          <Route path="tratamientos-odontologia" element={<PrivateRoute><TratamientosOdontologia /></PrivateRoute>} />
          <Route path="citas-odontologia" element={<PrivateRoute><CitasOdontologia /></PrivateRoute>} />
          <Route path="tipos-tratamiento-odontologia" element={<PrivateRoute><TiposTratamientoOdontologia /></PrivateRoute>} />
          <Route path="horarios-odontologia" element={<PrivateRoute><HorariosOdontologia /></PrivateRoute>} />
          <Route path="calendario-odontologia" element={<PrivateRoute><CalendarioCitasOdontologia /></PrivateRoute>} />
          <Route path="listado-citas-odontologia" element={<PrivateRoute><ListadoCitasOdontologia /></PrivateRoute>} />
          <Route path="medicos-odontologia" element={<PrivateRoute><MedicosOdontologia /></PrivateRoute>} />
          <Route path="configuracion-odontologia" element={<PrivateRoute><ConfiguracionOdontologia /></PrivateRoute>} />





        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default App;
